define('view/people/external.associations.detail.view',['require','exports','module','underscore','uikit/uikit','backbone.radio','fukit/fukit','fukit/fukit','fukit/fukit','fukit/fukit','fukit/fukit','fukit/fukit'],function(require, exports, module) {
  //prettier-ignore
  var _           = require('underscore'),
      UIKit       = require('uikit/uikit'),
      Radio       = require('backbone.radio'),
      RouteHelper = require('fukit/fukit').RouteHelper;

  //behaviors
  //prettier-ignore
  var EnableOnlyOnUnsavedChangesBehavior            = require('fukit/fukit').EnableOnlyOnUnsavedChangesBehavior,
      EnableLoadingOnModelRequestBehavior           = require('fukit/fukit').EnableLoadingOnModelRequestBehavior,
      InvokeModelMethodOnEventBehavior              = require('fukit/fukit').InvokeModelMethodOnEventBehavior,
      InvokeMethodOnEventBehavior                   = require('fukit/fukit').InvokeMethodOnEventBehavior,
      ShowModalOnNavigateWithUnsavedChangesBehavior = require('fukit/fukit').ShowModalOnNavigateWithUnsavedChangesBehavior;

  var DETAIL_LINK = 'externalassociations:detail';

  // It's an impl. Deal with it.
  var makeOrganizationDropdown = function makeOrganizationDropdownImpl(collection, organization) {
    return {
      type: UIKit.Dropdown,
      collection: collection,
      search: true,
      icon: 'search',
      fluid: true,
      placeholder: 'Select an organization...',
      bindings: {
        value: organization,
      },
      childBindings: {
        text: 'name',
      },
      behaviors: {
        setOrganizationIdFromDropdownValue: {
          events: {
            'change:value': function() {
              var context = this.getOption('context');
              if (this.view.value && this.view.value.id) {
                context.model.set('organizationId', this.view.value.id);
              }
            },
          },
          context: this,
          behaviorClass: InvokeMethodOnEventBehavior,
        },
      },
    };
  };

  var ExternalAssociationsDetailPageView = UIKit.ItemView.extend({
    className: 'page',
    template: 'external.associations.detail.page',
    behaviors: {
      // ShowModalOnNavigateWithUnsavedChanges: {
      //   behaviorClass: ShowModalOnNavigateWithUnsavedChangesBehavior,
      // },
    },

    internalViewOptions: {
      positionFormView: {
        type: UIKit.Form,
        showValidationMessage: false,
        showFieldValidationMessage: true,
      },
      organizationFormView: {
        type: UIKit.Form,
        showValidationMessage: false,
        showFieldValidationMessage: true,
      },
      organizationId: function() {
        var organization;
        var organizationId = this.model.get('organizationId');

        this.organizationsCollection.models = _.reject(this.organizationsCollection.models, function(organization) {
          //discard all inactive organizations unless used in the current external association
          return organization.get('active') !== true && organization.id !== organizationId;
        });

        if (!this.model.isNew()) {
          organization = this.organizationsCollection.get(this.model.get('organizationId'));
          if (organization) {
            this.model.set('organizationName', organization.get('name'));
          }
        }

        return makeOrganizationDropdown.bind(this)(this.organizationsCollection, organization);
      },
      title: function() {
        return {
          type: UIKit.Input,
          model: this.model,
          bindings: {
            value: 'title',
          },
        };
      },
    },

    initialize: function() {
      var state = Radio.request('AppKit.controllerService', 'state');

      UIKit.ItemView.prototype.initialize.apply(this, arguments);

      this.listenToOnce(this.organizationFormView.organizationId, 'render', function() {
        this._setOrganizationDropdownValue(this.organizationFormView.organizationId);
      });

      if (this.model.isNew()) {
        state.set('authorizationMode', 'create');
        this.listenToOnce(this.model, 'sync', function() {
          state.set('authorizationMode', null);
          RouteHelper.navigate(DETAIL_LINK, { id: this.model.id }, { replace: true });
        });
      }
    },

    primaryId: function() {
      var state = Radio.channel('AppKit.controllerService').request('state');
      return state.get('primaryId');
    },

    onInjectedOrganizationFormView: function() {
      var organizationDropdown = this.buildComponent({ name: 'organizationId' });

      this.bindOption('model', 'model', this.organizationFormView);
      this.organizationFormView.addField({ text: 'Organization', required: true }, organizationDropdown).parent();
    },

    onInjectedPositionFormView: function() {
      var titleInput = this.buildComponent({ name: 'title' });

      this.bindOption('model', 'model', this.positionFormView);
      this.positionFormView
        .addGroup()
        .addField({ text: 'Title', required: false }, titleInput)
        .parent()
        .parent();
    },

    _setOrganizationDropdownValue: function(dropdownView) {
      var organizationId = this.model.get('organizationId'),
        currentOrganization = dropdownView.collection.get(organizationId);

      dropdownView.value = currentOrganization;
      //reset "unsaved changes" caused by setting the dropdown value
      this.model.resetUnsavedChanges();
    },
  });

  module.exports = ExternalAssociationsDetailPageView;
});

